import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import Link from './link';
import { CONSTS } from './_constants';

type ListItemProps = {
    children?: any,
    to?:string,
    href?:string,
    onClick?: any,
    className?: string,
    style?:CSSProperties,
    meta?:any,
    active?: boolean
}
const ListItemComponent = (props: ListItemProps) => {
    return (
        <Link className={`${props.className}`} to={props.to} href={props.href} onClick={props.onClick} style={{...props.style}}>
            <div className={`_list-item ${props.active ? "_active" : ""}`}>
                <div className={`_content`}>{props.children}</div>
                {props.meta ? props.meta : <div></div>}
            </div>
        </Link>
    )
}
const ListItem = styled(ListItemComponent)`
${props=> props.meta ?
    `
    border-bottom: 1px solid rgba(63,63,68,.07);`
    : ``
}
    ._list-item {
        list-style: none;
        width: 100%;
        font-size: 14px;
        font-family: ${CONSTS.fonts.primary.light};
        color: ${CONSTS.colors.primaryDark};
        ${props=> props.meta ?
            `
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-betweem;
            align-items: stretch;
            ` : `
            border-bottom: 1px solid rgba(63,63,68,.07);
            display: flex;
            align-items: center;
            height: auto;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-left: 13px;
            padding-right: 13px;
        `}
        ${props => props.meta ? "" : "padding-left: 13px;"}
        min-height: 49px;
        box-sizing: border-box;
        cursor: pointer;
        transition: all .2s ease;
        &._active {
            color: ${CONSTS.colors.primary};
            background: ${CONSTS.colors.primaryLight};
        }
        a {
            transition: all .2s ease;
        }
        &:hover a{
            color: ${CONSTS.colors.primary};
        }
        &:hover {
            border-bottom: 1px solid rgba(63,63,68,.15);
            color: ${CONSTS.colors.primary};
        }
        ._content {
            height: auto;
            display: flex;
            align-items: center;
            ${props => props.meta ? `
            width: calc(100% - 50px);
            justify-content: flex-start;
            padding-right: 20px;
            padding-top: 10px;
            padding-bottom: 10px;
            ` : `
            justify-content: flex-start;
            `}
            flex-direction: row;
        }
    }
`
export default ListItem;